import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AnalyticsEvents as addonDiscoveryAnalyticsEvents } from '@atlassian/amkt-addon-discovery';
import { parse as parseAri } from '@atlassian/cs-ari';
import { foldAnalyticsEventType } from '@atlassian/mpac-analytics';
import { tenantType, userType } from '@atlassiansox/analytics-web-client';
import { Option } from 'funfix-core';
import { Map } from 'immutable';
import AnalyticsClient from '../Client';
import { allAnalyticsEvents } from '../Events';
import { allAnalyticsSources } from '../Sources';

// The events table is an O(1) lookup for all known events, mapping to which Analytics Web Client
// function we use to send that event.
// If an event doesn't exist in this table, it isn't registered, so we should throw an error.

export default class ProductPlatformBackend {
  constructor() {
    _defineProperty(this, "analyticsClient", null);
    _defineProperty(this, "eventsTable", Map());
  }
  initialize(hostInfo, userId) {
    return new Promise(resolve => {
      const client = AnalyticsClient.get();
      const cloudId = parseAri(hostInfo.globalContext.id).cloudId;
      const orgId = hostInfo.globalContext.orgId;
      const workspaceAri = parseAri(hostInfo.globalContext.workspaceAri).toString();
      client.setTenantInfo(tenantType.CLOUD_ID, cloudId);
      client.setOrgInfo(orgId);
      client.setWorkspaceInfo(workspaceAri);
      client.setUserInfo(userType.ATLASSIAN_ACCOUNT, userId);
      this.eventsTable = allAnalyticsEvents.concat(addonDiscoveryAnalyticsEvents).reduce((table, e) => table.setIn([e.action, e.actionSubject], foldAnalyticsEventType(e.type)(() => client.sendTrackEvent, () => client.sendUIEvent, () => client.sendOperationalEvent)), this.eventsTable);
      this.analyticsClient = client;
      resolve();
    });
  }
  sendPageViewEvent(pageViewEvent) {
    if (this.analyticsClient) {
      const analyticsClient = this.analyticsClient;
      if (!allAnalyticsSources.some(source => source.name === pageViewEvent.name)) {
        throw new Error("Unregistered source: ".concat(pageViewEvent.name, ". Add to analytics/Sources.js!"));
      }
      analyticsClient.sendScreenEvent({
        name: pageViewEvent.name,
        attributes: pageViewEvent.attributes
      });
    }
  }
  sendEvent(event) {
    if (this.analyticsClient) {
      Option.of(this.eventsTable.getIn([event.action, event.actionSubject])).map(send => send(event)).orElseL(() => {
        throw new Error("Unregistered event: ".concat(event.actionSubject, " ").concat(event.action, ". Add to analytics/Events.js!"));
      });
    }
  }
}